import React, { useEffect, useState } from "react";
import LeftSideBar, { FolderCollapse } from "../../components/SideBar/LeftSideBar";
import Navbar from "../../Layouts/Navbar/Navbar";
import { useCronContext } from "../../context/CronContext";
import { useTreeContext } from "../../context/TreeDataContext";
import { useModalContext } from "../../context/ModalContext";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useNavigationContext } from "../../context/NavigationContext";
import fileFolderConfig from "../../commonFunctions/fileFolderConfig";
import ResizableComponent from "../../Layouts/ResizableComponent";
import HeaderModes from "../../Layouts/Navbar/HeaderModes";
import { toastSuccess } from "../../utils/toastUtils";
import { deleteFolderOfFile, editFolderOrFile, insertNewFileOrFolder } from "../../utils/treeData/folderEditorUtils";
import ErrorMessage from "../../components/FormComponents/ErrorMessage";
import Button from "../../components/FormComponents/Button";
import Loader from "../../Layouts/Loader/Loader";

const CronSection = () => {
  const { selectedCron, fetchAllCron, setSelectedCron } = useCronContext();
  const { cronExplorerData, setCronExplorerData } = useTreeContext();
  const { getUserConfirmationForDelete } = useModalContext();

  const { saveChangesAndNavigate } = useNavigationContext();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { cronId } = useParams();

  const navigate = useNavigate();

  const handleNewInsert = async (folderId, name) => {
    try {
      const config = {
        name: name
      };
      const { data, message } = await axiosInstance.post(`/cronconfig`, config);
      const newItem = fileFolderConfig.getFileConfig(data.id, data.name, folderId.name); // new item alwas delete and editable

      const newTree = insertNewFileOrFolder(cronExplorerData, folderId, newItem);
      setCronExplorerData(newTree);
      navigate(`./${data.id}`);
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleDelete = async (folder) => {
    try {
      const userConfirmed = await getUserConfirmationForDelete(folder.name);
      if (!userConfirmed) return;

      const { message } = await axiosInstance.delete(`/cronconfig/${folder.id}`);
      const newTree = deleteFolderOfFile(cronExplorerData, folder);
      setCronExplorerData(newTree);
      if (folder.id === selectedCron?.id) navigate(`./`);

      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const handleEdit = async (folder, newName) => {
    try {
      const config = {
        name: newName
      };
      const { message } = await axiosInstance.put(`/cronconfig/${folder.id}`, config);

      const newTree = editFolderOrFile(cronExplorerData, folder, newName);
      setCronExplorerData(newTree);

      if (folder.id === selectedCron?.id) {
        setSelectedCron({ ...selectedCron, name: newName });
      }

      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  const callbackFunction = (id) => {
    if (id === selectedCron.id) return;
    saveChangesAndNavigate(id);
  };

  const initialFetching = async () => {
    setIsLoading(true);
    setIsError(false);
    try {
      // await fetchAllCron();
      if (cronExplorerData && cronExplorerData.length > 0) {
        if (selectedCron.id && !cronId) {
          setSelectedCron({ id: "" });
        }
      } else {
        await fetchAllCron();
      }
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    initialFetching();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <section className="main_section">
        <div className="sub_section">
          <ResizableComponent
            resizeSide="right"
            storageKey="left_sidebar_size"
            defaultSize={244}
            range={[244, 400]} // Specify the range as [minSize, maxSize]
            collapsible={true}
          >
            <HeaderModes />
            <div className="d_flex">
              <Navbar />
              {isError ? (
                <div className="d_flex align_center justify_center flex_column">
                  <ErrorMessage className={"text_center mb_3"}>Failed to load Cron. Please try again</ErrorMessage>
                  <Button onClick={initialFetching}>Retry</Button>
                </div>
              ) : (
                <LeftSideBar
                  explorerData={cronExplorerData}
                  setExplorerData={setCronExplorerData}
                  selectedScreen={selectedCron}
                  handleNewInsert={handleNewInsert}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  callbackFunction={callbackFunction}
                  type="CRON"
                >
                  <div className="d_flex align_center gap_3">
                    <FolderCollapse explorerData={cronExplorerData} setExplorerData={setCronExplorerData} type="cron" />
                  </div>
                </LeftSideBar>
              )}
            </div>
          </ResizableComponent>
          {isLoading ? <Loader /> : <Outlet />}
        </div>
      </section>
    </>
  );
};

export default CronSection;
